import { API_GET_AVAILABLE_LANGUAGES, API_GET_TRANSLATIONS } from 'constants/db.constants';
import _ from 'lodash';
import API from 'services/api.services';
import { setAvailableLanguages, setLoading } from 'state/reducers/translation.reducers';

export async function fetchTranslations(lang: string) {
	const paramsSetting = {
		languageCode: lang,
	};
	const result = await API.getInstance().get(API_GET_TRANSLATIONS, paramsSetting);
	const { translations, plansHebrewContent, welcomeHebrewContent } = result.data;
	return {
		translations,
		plansHebrewContent,
		welcomeHebrewContent,
	};
}

export function fetchAvailableLanguages() {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		await API.getInstance()
			.get(API_GET_AVAILABLE_LANGUAGES)
			.then((response) => {
				dispatch(setLoading(false));
				dispatch(setAvailableLanguages(response.data.languages));
			})
			.catch((error) => {
				dispatch(setLoading(false));
				dispatch(setAvailableLanguages(null));
			});
	};
}
